<template>
  <router-link
    :to="to"
    :class="classes"
    class="nav-bar-entry--link"
  >
    <font-awesome-icon
      v-if="hasIcon"
      :icon="icon"
      class="nav-bar-entry__icon"
    />
    <span class="nav-bar-entry__label visible-md">
      {{ label }}
    </span>
  </router-link>
</template>

<script>
import NavBarEntryMixin from '@/mixins/ui/NavBarEntry'

export default {
  name: 'NavBarLink',
  mixins: [NavBarEntryMixin],
  props: {
    to: {
      type: [Object, String],
      required: true
    }
  },
  computed: {
    classes () {
      return {
        [`nav-bar-entry--${this.position}`]: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/NavBarLink.vue